export const Main_Color = "#0099ff";
